
<script>

import { defineComponent } from 'vue'

import Editor from '@tinymce/tinymce-vue'

/* Default icons are required for TinyMCE 5.3 or above */
import 'tinymce/icons/default';

/* A theme is also required */
import 'tinymce/themes/silver';

/* Import the skin */
import 'tinymce/skins/ui/oxide/skin.css';

/* Import plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';

export default defineComponent({
  name: 'tinyMCEeditorGeneral',
	data() {
		return {
      obsah:""
      ,workContent:""
			,initObj: {
				relative_urls: false
				,convert_urls: false
				,remove_script_host:false
				,height:400
				,entity_encoding : "raw" 
				,language:'sk'
				,extended_valid_elements: 'i[class]'
				,iconfonts_selector: '.fa, .fab, .fal, .far, .fas, .glyphicon'
        ,plugins: 'wordcount, advlist, autolink, link, image, lists, charmap, print, preview, hr, anchor, pagebreak, spellchecker, searchreplace, visualblocks, visualchars, code, fullscreen, insertdatetime, media, nonbreaking, save, table, directionality, emoticons, template, paste'
        ,toolbar: 'undo redo | copy cut paste | formatselect | bold italic underline backcolor forecolor | link image table | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',

			},
		}
	},
  props: {
    'content': String
  },
  emits: ["content","changeContent"],
  components: {
    'editor': Editor
  }
  ,mounted () {
    this.workContent = this.content;
  },
  
	methods: {
    loadContent:function(){
      this.$emit('changeContent', this.workContent)
    }
	},
	
	watch: {
   
	},
	
	created() {

	}
  
})
</script>

<template>
  <div>
    <editor tinymce-script-src="tinymce/tinymce.min.js" v-model="workContent" :init="initObj"  @selectionChange="loadContent" />
  </div>
</template>